@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
.icon {
  height: 20px;
  width: 20px;
  border-radius: $border-radius-round;
  border: $border-width-2 solid $zv-border--gray-41-2;
  background-color: $zv-control--Primary-BG-Color;
  outline-offset: 2px;
  outline: none;
}

.checkedIcon {
  // outline: 1px solid #696969;
  // outline-offset: 0px;
  // border: 2px solid $White;
  // height: 20px;
  // width: 20px;
  // border-radius: 50%;
  // // background-color: $Primary-BG-Color;

  height: 20px;
  width: 20px;
  border-radius: $border-radius-round;
  border: $border-width-2 solid $zv-border--gray-41-2;
  background-color: $zv-control--Primary-BG-Color;
  outline-offset: 2px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  .selected {
    height: 16px;
    width: 16px;
    border-radius: $border-radius-round;
    border: $border-width-selected solid $zv-control--White;
    background-color: $zv-icon--blue-18;
    outline-offset: 0px;
    outline: none;
  }
}
